import { render, staticRenderFns } from "./vehicle-refund.vue?vue&type=template&id=3015065c&scoped=true"
import script from "./vehicle-refund.vue?vue&type=script&lang=js"
export * from "./vehicle-refund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015065c",
  null
  
)

export default component.exports